module.exports = __webpack_public_path__ + "media/images/ohap_assignment_off-133b58b383bd15b61ba2d8a1d3d3f550.png";